import React from 'react';
import PropTypes from 'prop-types';

import ImageLoader from '@stubhub/react-image-loader';

import helper from './cloudinary-url-helper';

/**
 * @deprecated This media will probably be replaced in the future with CloudinaryImage that uses cloudinary SDK
 */
const CloudinaryMedia = (
  {
    src,
    publicIdSrc,
    alt,
    publicId,
    extension,
    className,
    onLoad,
    onError,
    enableCloudinary,
    useNamedTransforms,
    ...transformations
  },
  {logger}
) => {
  if (extension) {
    if (helper.supportedVideoTypesRegExp.test(extension)) {
      const cloudinaryVideoURL = enableCloudinary
        ? helper.getCloudinaryVideoURL({src, publicIdSrc, publicId, extension, ...transformations})
        : src;

      return cloudinaryVideoURL ? (
        <video autoPlay muted loop onError={onError}>
          <source src={cloudinaryVideoURL} type={`video/${extension}`} />
        </video>
      ) : null;
    } else if (helper.supportedImageTypesRegExp.test(extension)) {
      const cloudinaryImageURL = enableCloudinary
        ? helper.getCloudinaryImageURL({src, publicIdSrc, publicId, extension, useNamedTransforms, ...transformations})
        : src;

      return cloudinaryImageURL ? (
        <ImageLoader className={className} imgSrc={cloudinaryImageURL} alt={alt} onLoad={onLoad} onError={onError} />
      ) : null;
    }
    const extensionNotSupported = `MIME type not supported: ${extension}`;
    const missingSource = 'File path or extension not provided to CloudinaryMedia';
    logger && logger.error(extension ? extensionNotSupported : missingSource);

    return null;
  }
  const cloudinaryImageURL = enableCloudinary
    ? helper.getCloudinaryImageURL({src, publicIdSrc, publicId, extension, useNamedTransforms, ...transformations})
    : src;

  return cloudinaryImageURL ? (
    <ImageLoader className={className} imgSrc={cloudinaryImageURL} alt={alt} onLoad={onLoad} onError={onError} />
  ) : null;
};

CloudinaryMedia.propTypes = {
  src: PropTypes.string,
  publicId: PropTypes.string,
  extension: PropTypes.string,
  onLoad: PropTypes.func,
  onError: PropTypes.func,
  enableCloudinary: PropTypes.bool,
  useNamedTransforms: PropTypes.bool,

  publicIdSrc: PropTypes.string,
  alt: PropTypes.string,
  className: PropTypes.string,

  /**
   * Transformations
   *
   */
  quality: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  crop: PropTypes.string,
  gravity: PropTypes.string,
  zoom: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  opacity: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  format: PropTypes.string,
};

CloudinaryMedia.contextTypes = {
  logger: PropTypes.object,
};

export default CloudinaryMedia;
export {default as helper} from './cloudinary-url-helper';
export {default as CloudinaryImage} from './CloudinaryImage';
